<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    :width="isZh?'750px':'850px'"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <el-form :inline="true" :label-width="isZh?'80px':'130px'" label-position="left">
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Parter') }}</span>
            <cargo-advance-select
              no="partnerId"
              :disabled="type === 'renew' || readOnly || type === 'edit'"
              :select-type="selectTypeNames.basic_data_Company"
              filterable
              style="width: 230px;"
              :method-params="{active:true}"
              :default-value="contract.partnerId||''"
              @parentCallBack="p=>{contract.partnerId=p.value || 0;contract.branchId=$store.getters.currentOfficeId}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ContractNumber') }}</span>
            <el-input v-model="contract.contractNo" no="contractNo" style="width: 230px;" :disabled="readOnly" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="type === 'edit' || type === 'look'">
        <el-col :span="24">
          <el-form-item :label="$t('CargoMsg.Cargo_CustomerLevel')">
            <el-select
              v-model="contract.customerType"
              no="customerType"
              :disabled="readOnly"
              style="width: 230px;"
            >
              <el-option
                v-for="(item,index) in customerTypeList"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.typeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContractStatus')">
            <el-select
              v-model="contract.contractState"
              no="contractState"
              :disabled="readOnly"
              style="width: 230px;"
            >
              <el-option
                v-for="(item,index) in contractStateList"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_EffectiveDate') }}</span>
            <el-date-picker v-model="contract.beginDate" no="beginDate" :editable="false" :disabled="readOnly" type="date" value-format="yyyy-MM-dd" style="width: 230px;" />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_InvalidDate') }}</span>
            <el-date-picker v-model="contract.endDate" no="endDate" :editable="false" :disabled="readOnly" type="date" value-format="yyyy-MM-dd" style="width: 230px;" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="type === 'edit' || type === 'look'">
        <el-col :span="24">
          <el-form-item :label="$t('CargoMsg.Cargo_ContractType')">
            <el-select
              v-model="contract.contractType"
              no="contractType"
              :disabled="true"
              style="width: 230px;"
            >
              <el-option
                v-for="(item,index) in ContractConstants.CONTRACT_TYPE"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0">
            <el-checkbox v-model="contract.clearCreditAtExpire" :disabled="type === 'look'">{{ $t('Information.ClearCreditExpiration') }}</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('CargoMsg.Cargo_ApplicationRules')">
            <el-select v-model="contract.contractRuleUuid" no="contractRuleUuid" :disabled="type === 'look'" style="width: 230px;" @change="$forceUpdate()">
              <el-option
                v-for="(item,index) in contractRuleDownList"
                :key="index"
                :label="item.name"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
          <el-form-item label-width="0">
            <el-checkbox v-model="cm.contactMultiple" :disabled="editContactMultiple" @change="contactMultipleChange">{{ $t('CargoMsg.Cargo_ContactMultiple') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="type === 'add' || type === 'renew'">
        <el-col :span="24">
          <el-form-item :label="$t('CargoMsg.Cargo_ApplicationRules')">
            <el-select v-model="contract.contractRuleUuid" no="contractRuleUuid" style="width: 230px;" @change="$forceUpdate()">
              <el-option
                v-for="(item,index) in contractRuleDownList"
                :key="index"
                :label="item.name"
                :value="item.uuid"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label-width="0">
            <el-checkbox v-model="contract.clearCreditAtExpire">{{ $t('Information.ClearCreditExpiration') }}</el-checkbox>
          </el-form-item>
          <el-form-item label-width="0">
            <el-checkbox v-model="cm.contactMultiple" :disabled="editContactMultiple" @change="contactMultipleChange">{{ $t('CargoMsg.Cargo_ContactMultiple') }}</el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!cm.contactMultiple">
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ContractAgreement') }}</span>
            <el-radio-group v-model="contract.contractAgreement" no="contractAgreement" :disabled="readOnly">
              <el-radio :label="1">{{ $t('CargoMsg.Cargo_ClientContract') }}</el-radio>
              <el-radio :label="2">{{ $t('CargoMsg.Cargo_SupplierContract') }}</el-radio>
              <el-radio :label="3">{{ $t('CargoMsg.Cargo_OverseasAgencyContract') }}</el-radio>
              <el-radio :label="9">{{ $t('CargoMsg.Cargo_OtherContact') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="cm.contactMultiple">
        <el-col :span="24">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_ContractAgreement') }}</span>
            <el-checkbox v-model="cm.clientContract" :disabled="editContactMultiple" style="margin-left: 2px;">{{ $t('CargoMsg.Cargo_ClientContract') }}</el-checkbox>
            <el-checkbox v-model="cm.supplierContract" :disabled="editContactMultiple" style="margin-left: 2px;">{{ $t('CargoMsg.Cargo_SupplierContract') }}</el-checkbox>
            <el-checkbox v-model="cm.overseasAgencyContract" :disabled="editContactMultiple" style="margin-left: 2px;">{{ $t('CargoMsg.Cargo_OverseasAgencyContract') }}</el-checkbox>
            <el-checkbox v-model="cm.otherContact" :disabled="editContactMultiple" style="margin-left: 2px;">{{ $t('CargoMsg.Cargo_OtherContact') }}</el-checkbox>

            <span class="title" style="padding-left: 30px"><i class="el-icon-warning icon-tip" :title="$t('CargoMsg.Cargo_ContractTip')" /></span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="contract.remarks" no="remarks" type="textarea" :rows="3" style="width: 540px;" :disabled="readOnly" />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="border-bottom: 2px solid #E3E3E3; margin-bottom: 10px; margin-top: 10px;" />
      <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_CurrentCredit') }}</span>
      <el-row v-if="contract.contractRuleUuid === RULE_ALL_ORDERS.code">
        <el-col :span="24">
          <el-form-item :label="$t('Partners.limit')">
            <el-input-number
              v-model="contract.currentCredit"
              no="credit"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <el-select v-model="contract.currentCurrency" no="currency" style="margin-left:5px;width:88px;" disabled>
              <el-option
                v-for="(item,index) in currencySet"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')">
            <el-input-number
              v-model="contract.currentDateLimited"
              no="dateLimited"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px;"
            />
            <el-select v-model="contract.currentTermUnit" no="termUnit" style="margin-left:5px;width:70px;" disabled>
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="contract.contractRuleUuid !== RULE_ALL_ORDERS.code">
        <el-col :span="24">
          <el-form-item :label="$t('Partners.limit')">
            <el-input-number
              v-model="contract.credit"
              no="credit"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <el-select v-model="contract.currency" no="currency" style="margin-left:5px;width:88px;" disabled>
              <el-option
                v-for="(item,index) in currencySet"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')">
            <el-input-number
              v-model="contract.dateLimited"
              no="dateLimited"
              disabled
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px;"
            />
            <el-select v-model="contract.termUnit" no="termUnit" style="margin-left:5px;width:70px;" disabled>
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <span>{{ $t('CargoMsg.Cargo_CurrentCreditNotice') }}</span> -->
      <div style="border-bottom: 2px solid #E3E3E3; margin-bottom: 10px; margin-top: 10px;" />
      <span style="line-height: 25px; font-weight: bold;">{{ $t('CargoMsg.Cargo_ContractTerms') }}</span>
      <el-row style="margin-top: 10px;">
        <el-col :span="24">
          <el-form-item :label="$t('Partners.dateType')">
            <el-select v-model="contract.dateType" no="dateType" style="width: 163px;" :disabled="readOnly">
              <el-option
                v-for="(item,index) in dateTypeList"
                :key="index"
                :label="$getLangColumn(item)"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.settlementMethod')">
            <el-select v-model="cbType" no="cbType" :disabled="readOnly">
              <el-option
                v-for="(item,index) in cbTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-input-number
            v-if="cbType==='n'"
            no="tiDateSpecify"
            :disabled="readOnly"
            :value="tiDateSpecify||undefined"
            :min="0"
            :max="31"
            :precision="0"
            :controls="false"
            style="width:70px;"
            @input="val=>{this.tiDateSpecify=val}"
          />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('Partners.limit')">
            <el-input-number
              v-model="contract.snapCredit"
              no="credit"
              :disabled="readOnly"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:70px;"
            />
            <el-select v-model="contract.currency" no="currency" style="margin-left:5px;width:88px;" :disabled="readOnly" @change="currencyChanged">
              <el-option
                v-for="(item,index) in currencySet"
                :key="index"
                :label="item.code"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.accountPeriod')">
            <el-input-number
              v-model="contract.snapCreditDateLimited"
              no="dateLimited"
              :disabled="readOnly || showActualCreditGracePeriodDays"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px;"
            />
            <el-select v-model="contract.termUnit" no="termUnit" style="margin-left:5px;width:70px;" :disabled="readOnly || showActualCreditGracePeriodDays">
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-show="showActualCreditGracePeriodDays" :span="24">
          <el-form-item :label="$t('Payment.paymentPeriod')">
            <el-input-number
              v-model="contract.paymentTerm"
              no="paymentTerm"
              :disabled="readOnly"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:74px"
              @change="value => changePaymentTerm(value)"
            />
            <el-select v-model="contract.paymentTermUnit" no="paymentTermUnit" style="margin-left:5px;width:70px;" :disabled="readOnly" @change="(value) => changePaymentTermUnit(value)">
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('Partners.settlementType')">
            <el-radio-group v-model="settlementByBill" no="settlementByBill" :disabled="true">
              <el-radio :label="false">{{ $t('Partners.settlementByBill') }}</el-radio>
              <el-radio :label="true">{{ $t('Partners.settlementNotByBill') + '（' + $t('CargoMsg.Cargo_SettlementMethodGreaterThan0') + '）' }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item>
            <el-checkbox v-model="contract.postpone" no="postpone" :disabled="readOnly">{{ $t('CargoMsg.Cargo_ExtensionAfterExpiration') }}</el-checkbox>
          </el-form-item>
          <span v-if="contract.postpone" style="margin-left: 20px;">
            <el-form-item :label="$t('CargoMsg.Cargo_ExtensionCycle')">
              <el-radio-group v-model="contract.postponeType" no="postponeType" :disabled="readOnly" @change="postponeTypeChangeHandler">
                <el-radio :label="1">{{ $t('CargoMsg.Cargo_1Year') }}</el-radio>
                <el-radio :label="2">{{ $t('CargoMsg.Cargo_2Years') }}</el-radio>
                <el-radio :label="3">{{ $t('CargoMsg.Cargo_3Years') }}</el-radio>
                <el-radio :label="9">{{ $t('CargoMsg.Cargo_Other') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-input-number
              v-if="contract.postponeType === 9"
              v-model="contract.postponeLimited"
              no="postponeLimited"
              :disabled="readOnly"
              :min="0"
              :precision="0"
              :controls="false"
              style="width:60px;margin-right: 5px;"
              @change="postponeTypeChangeHandler"
            />
            <el-select v-if="contract.postponeType === 9" v-model="contract.postponeUnit" no="postponeUnit" :disabled="readOnly" style="width: 60px;" @change="postponeTypeChangeHandler">
              <el-option :label="$t('Partners.day')" :value="0" />
              <el-option :label="$t('Partners.week')" :value="1" />
              <el-option :label="$t('Partners.month')" :value="2" />
            </el-select>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%;margin-bottom: 8px">
      <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TempCredit')" name="otherDocuments" style="width:100%;height: 100%">
        <div class="app-main-inner-row row-grid" style="min-height:300px;">
          <cargo-ag-grid
            :column-defs="tempCreditInfo.columnDefs"
            :grid-options="tempCreditInfo.gridOptions"
            :row-data="tempCreditInfo.rowData"
            :show-side-bar="false"
            style="height:100%;min-height: 220px;"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
    <span>{{ $t('CargoMsg.Cargo_TempCreditNotice') }}</span>
    <div slot="footer" style="text-align: center;">
      <el-button v-if="type === 'renew'" no="oneClickRenewal" type="primary" :disabled="saveBtnEnabled" @click="saveEventHander">{{ $t('CargoMsg.Cargo_OneClickRenewal') }}</el-button>
      <el-button v-if="!readOnly && type !== 'renew'" no="confirm" type="primary" :disabled="saveBtnEnabled" @click="saveEventHander">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ !readOnly ? $t('CargoMsg.Cargo_Cancel') : $t('CargoMsg.Cargo_DisableOpen') }}</el-button>
    </div>
    <!-- 合同bpm申请弹框    -->
    <contract-apply-dialog
      v-if="contractApplyWindow.visible"
      ref="contractApplyDialog"
      :visible.sync="contractApplyWindow.visible"
      :contract-bpm="contractApplyWindow.contractBpm"
      :title="$t('CargoMsg.Cargo_ContractApplicationApprovalProcess')"
      type="apply"
      @close="contractApplyWindow.visible=false; saveBtnEnabled = false"
      @closeAndRefresh="closeAndRefresh"
    />
  </el-dialog>
</template>

<script>

import { Contract } from '@/class/model/mdm/Contract'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ContractConstants from '@/class/cargo/model/parameters/ContractConstants'
import { getLoading } from '@/utils/utilBaseElement'
import { getCompanyHasContractCount, saveContractInfo } from '@/api/partner/contract'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getCacheListByKey, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { getContractRules } from '@/api/partner/contractRule'
import {
  CONTRACTAGREEMENT_CUSTOMER, CONTRACTAGREEMENT_OTHER, CONTRACTAGREEMENT_OVERSEAAGENT,
  CONTRACTAGREEMENT_SUPPLIER,
  RULE_ALL_ORDERS, UNIT_DAY
} from '@/class/cargo/model/parameters/ContractConstants'
import { createContractBpmFunc } from '@/api/partner/contractBpm'
import ContractApplyDialog from '@/components/Cargo/Common/Wrokflow/contractApplyDialog.vue'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { CONTRACT_APPLICATION_FORM } from '@/class/cargo/model/parameters/WorkflowConstants'

export default {
  name: 'ContractEditWindow',
  components: { ContractApplyDialog, cargoAdvanceSelect },
  props: {
    type: { type: String, required: true },
    visible: { type: Boolean, required: true },
    model: { type: Object, required: true, default: null }
  },
  data() {
    return {
      ContractConstants,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      saveBtnEnabled: false,
      config: {},
      creditUseMultipleCurrency: false,
      actualCreditGracePeriodDays: 0,
      dateTypeList: [],
      cbType: '',
      cbTypeList: [],
      tiDateSpecify: '',
      activeTabName: 'otherDocuments',
      tempCreditInfo: {
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
            field: 'effectiveDate',
            colId: 'effectiveDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
            field: 'expirationDate',
            colId: 'expirationDate',
            width: 180,
            minWidth: 180,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Partners.credit_limit'),
            field: 'credit',
            colId: 'credit',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.CreditUnit'),
            field: 'currency',
            colId: 'currency',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.credit_accountPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 80,
            minWidth: 80
          },
          {
            headerName: this.$t('Partners.creditDateUnit'),
            field: 'termUnit',
            colId: 'termUnit',
            width: 80,
            minWidth: 80,
            cellRenderer: (params) => {
              const termMap = this.termUnitList.find(item => item.value === params.value)
              if (termMap) {
                return termMap.name
              }
              return ''
            }
          }
        ],
        gridOptions: {
          // 单击显示编辑
          singleClickEdit: true,
          onSortChanged: this.rowDataChanged
        },
        rowData: []
      },
      chkPostpone: false,
      contractStateList: [],
      customerTypeList: [],
      oldContract: null,
      cm: {
        contactMultiple: false,
        clientContract: false,
        supplierContract: false,
        overseasAgencyContract: false,
        otherContact: false
      },
      contractApplyWindow: {
        visible: false,
        contractBpm: {}
      },
      contract: new Contract().fillDefaultValue().getData(),
      lastCurrency: '',
      isBpmEnabled: false,
      currencySet: new Set(),
      contractRuleDownList: [],
      RULE_ALL_ORDERS: RULE_ALL_ORDERS,
      termUnitList: [
        { value: 0, name: this.$t('Partners.day') },
        { value: 1, name: this.$t('Partners.week') },
        { value: 2, name: this.$t('Partners.month') }
      ]
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    title() {
      if (this.type === 'add') return this.$t('CargoMsg.Cargo_AddContract')
      if (this.type === 'edit') return this.$t('CargoMsg.Cargo_EditContract')
      if (this.type === 'renew') return this.$t('CargoMsg.Cargo_RenewContract')
      return this.$t('CargoMsg.Cargo_ViewContract')
    },
    editContactMultiple() {
      if (this.type === 'look' || this.type === 'renew') {
        return true
      }
      if (this.contract.associationList && this.contract.associationList.length > 0) {
        return true
      }
      return false
    },
    readOnly() {
      return this.type === 'look'
    },
    showActualCreditGracePeriodDays() {
      return this.actualCreditGracePeriodDays > 0
    },
    settlementByBill() { // 结算方式
      return parseInt(this.contract.snapCreditDateLimited) > 0 || (this.cbType && this.cbType === 'n')
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    // 初始化【应用规则】列表
    await getContractRules().then(res => {
      this.contractRuleDownList = res.data
    })
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    async init() {
      this.saveBtnEnabled = false
      this.tempCreditInfo.rowData = []
      await cache.load(cacheName.CONFIG)
      this.config = cache.config
      this.creditUseMultipleCurrency = Number(this.config.get('creditUseMultipleCurrency')) === 1
      this.actualCreditGracePeriodDays = Number(this.config.get('actualCreditGracePeriodDays'))
      this.dateTypeList = ContractConstants.DATETYPE_TYPE
      this.cbTypeList = [
        { label: this.$t('Partners.monthlySettlement'), value: -1 },
        { label: this.$t('Partners.space3'), value: -2 },
        { label: this.$t('Partners.space4'), value: 'n' },
        { label: this.$t('Partners.space5'), value: -3 },
        { label: this.$t('Partners.dailySettlement'), value: -4 }
      ]
      if (this.model) {
        Object.assign(this.contract, this.model)
      }

      if (this.type === 'edit') this.oldContract = { ...this.contract }
      if (!this.contract) return
      if (this.contract.tempCreditInfoList) {
        this.tempCreditInfo.rowData = this.contract.tempCreditInfoList
      }
      this.fillView()
      this.initCurrencySet()
      this.lastCurrency = this.contract.currency
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: CONTRACT_APPLICATION_FORM.code,
        officeId: this.$store.getters.currentOfficeId
      })
    },
    fillView() {
      this.contract.contractState = parseInt(this.contract.contractState)
      this.contract.postpone = this.contract.postpone === 1

      // 编辑 查看专用
      if (this.type === 'edit' || this.type === 'look') {
        // 客户级别
        this.contract.customerType = parseInt(this.contract.customerType) || 0
        this.customerTypeList = getCacheListByKey(basicCacheKeys.basic_data_CustomerType)

        // 只显示终止合作和当前状态
        this.contractStateList = []
        const curContractState = CommonState.getStateByCode(ContractConstants.CONTRACT_STATUS, this.contract.contractState)
        if (curContractState && this.contract.contractState !== ContractConstants.STAGE_TERMINATE.code) this.contractStateList.push(curContractState)
        this.contractStateList.push(ContractConstants.STAGE_TERMINATE)
        if (!this.contract.contractState) this.contract.contractState = this.contractStateList[0].code

        // 合同类型
        const contractTypeList = ContractConstants.CONTRACT_TYPE
        if (!this.contract.contractType) this.contract.contractType = contractTypeList[0].code
      }

      // 结算方式
      if (this.contract.creditDateType === -1 || this.contract.creditDateType === 0) {
        this.cbType = -1
      } else if (this.contract.creditDateType === -2) {
        this.cbType = -2
      } else if (this.contract.creditDateType === -3) {
        this.cbType = -3
      } else if (this.contract.creditDateType === -4) {
        this.cbType = -4
      } else if (this.contract.creditDateType > 0) {
        this.cbType = 'n'
        this.tiDateSpecify = this.contract.creditDateType
      }

      if (!this.contract.contractRuleUuid) {
        // 应用规则 默认 【全部订单】
        this.contract.contractRuleUuid = RULE_ALL_ORDERS.code
      }
      if (this.contract.contractBatchNo && this.contract.associationList) {
        this.cm.contactMultiple = true
        for (const c of this.contract.associationList) {
          switch (c) {
            case CONTRACTAGREEMENT_CUSTOMER.code:
              this.cm.clientContract = true
              break
            case CONTRACTAGREEMENT_SUPPLIER.code:
              this.cm.supplierContract = true
              break
            case CONTRACTAGREEMENT_OVERSEAAGENT.code:
              this.cm.overseasAgencyContract = true
              break
            case CONTRACTAGREEMENT_OTHER.code:
              this.cm.otherContact = true
              break
          }
        }
      }
    },
    // 保存
    saveEventHander() {
      if (this.saveBtnEnabled) return
      this.saveBtnEnabled = true
      if (!this.checkContract(this.contract)) return
      this.contract.type = this.type

      // 编辑
      if (this.type === 'edit') {
        this.contract.creditDateType = this.cbType === 'n' ? this.tiDateSpecify : this.cbType
        if (this.checkIsNeedSyshcronize(this.contract) && (parseInt(this.contract.contractState) === ContractConstants.STAGE_WILLEXPIRED.code ||
          parseInt(this.contract.contractState) === ContractConstants.STAGE_UNEXPIRED.code)) {
          this.contract.isNeedSyshcronize = 1
        }
        // 合同协议处理
        const newAgreement = this.contract.contractAgreement
        // CARGO-10072 亚东：合同管理中额度未在信用账款中同步；信用控制中额度未取合同管理中额度
        if (this.oldContract.contractAgreement === 1 && newAgreement !== 1) {
          this.contract.isNeedSyshcronize = 0
        }
        if (this.oldContract.contractAgreement !== newAgreement && newAgreement === 1) {
          this.contract.isNeedSyshcronize = 1
        }
        this.save()
        return
      }

      // 续签
      if (this.type === 'renew') {
        this.contract.contractType = ContractConstants.RENEW_CONTRACT.code
        this.contract.contractState = ContractConstants.STAGE_RENEW.code
        this.contract.creditDateType = this.cbType === 'n' ? this.tiDateSpecify : this.cbType
        this.save()
        return
      }

      // 新增
      if (this.type === 'add') {
        this.contract.contractType = ContractConstants.FIRST_SIGN.code
        this.contract.creditDateType = this.cbType === 'n' ? this.tiDateSpecify : this.cbType
        getCompanyHasContractCount(this.contract).then(res => {
          const result = res.data
          if (result && parseInt(result) > 0) { // CARGO-7989，新增无效
            const label = ColumnUtils.contractColumnLabelFunc(ContractConstants.CONTRACTAGREEMENT_TYPE, this.contract.contractAgreement)
            const warning = !label ? '合同' : label
            this.$message.warning('该客户已签订' + warning + '，可选择该客户进行续签！')
            this.saveBtnEnabled = false
            return
          }
          this.save()
        })
      }
    },
    save() {
      // 多合同协议暂时没有审批流
      if (!this.cm.contactMultiple && this.isBpmEnabled) {
        this.$confirm(this.$t('CargoMsg.Cargo_ContractApprovalRequired'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.doSave(true)
        }).catch(() => {
          this.doSave(false)
        })
      } else {
        this.doSave(false)
      }
    },
    // 公共保存方法
    doSave(doBpm) {
      this.$logger.log('this.contract======保存之前', this.contract)
      this.loading = getLoading()
      const contractTypes = {
        clientContract: CONTRACTAGREEMENT_CUSTOMER.code,
        supplierContract: CONTRACTAGREEMENT_SUPPLIER.code,
        overseasAgencyContract: CONTRACTAGREEMENT_OVERSEAAGENT.code,
        otherContact: CONTRACTAGREEMENT_OTHER.code
      }
      this.contract.contractAgreementList = Object.keys(contractTypes).reduce((list, key) => {
        if (this.cm[key]) {
          list.push(contractTypes[key])
        }
        return list
      }, [])
      if (!this.cm.contactMultiple && this.isBpmEnabled) {
        // 修改或新增时状态为待审核
        this.contract.state = ContractConstants.REVIEW_STAGE_DRAFT.code
        this.contract.needBpm = doBpm // 标记是需要审批的
      }
      saveContractInfo(this.contract).then(res => {
        if (doBpm) {
          this.doContractBpmHandler(res.data)
        } else {
          this.$message.success(this.$t('Information.SavedSuccessfully'))
          this.$emit('reload')
          this.innerVisible = false
        }
      }).catch(() => {
        // 验证合同唯一性，报错修改后还能继续保存
        this.saveBtnEnabled = false
      }).finally(() => {
        this.loading.close()
      })
    },
    async doContractBpmHandler(contract) {
      createContractBpmFunc(contract).then(res => {
        if (res.data) {
          this.contractApplyWindow.contractBpm = res.data
          setTimeout(() => {
            this.$nextTick(() => {
              this.contractApplyWindow.visible = true
            })
          }, 100)
        }
      })
    },
    closeAndRefresh() {
      this.$emit('reload')
      this.innerVisible = false
    },
    checkIsNeedSyshcronize(contract) {
      if (!contract || !this.oldContract) {
        return false
      }
      if (contract.dateType !== this.oldContract.dateType ||
        contract.credit !== this.oldContract.credit || contract.currency !== this.oldContract.currency ||
        contract.dateLimited !== this.oldContract.dateLimited || contract.termUnit !== this.oldContract.termUnit) {
        return true
      }

      if (this.oldContract.creditDateType === 0 && contract.creditDateType === -1 || this.oldContract.creditDateType === contract.creditDateType) {
        return false
      }
      return true
    },
    // 保存前验证
    checkContract(contract) {
      if (!contract.partnerId || contract.partnerId === 0) {
        this.$message.warning(this.$t('Information.PartnerCannotBeEmpty'))
        this.saveBtnEnabled = false
        return false
      }
      if (!contract.contractNo) {
        this.$message.warning(this.$t('Information.ContractNumberCannotBeEmpty'))
        this.saveBtnEnabled = false
        return false
      }
      if (!contract.beginDate) {
        this.$message.warning(this.$t('Information.EffectiveDateCannotBeEmpty'))
        this.saveBtnEnabled = false
        return false
      }
      if (!contract.endDate) {
        this.$message.warning(this.$t('Information.ExpirationDateCannotBeEmpty'))
        this.saveBtnEnabled = false
        return false
      }
      if (contract.contractAgreement === 0) {
        this.$message.warning(this.$t('Information.ContractAgreementCannotBeEmpty'))
        this.saveBtnEnabled = false
        return false
      }
      if (this.cm.contactMultiple && !this.cm.clientContract &&
        !this.cm.supplierContract && !this.cm.overseasAgencyContract && !this.cm.otherContact) {
        this.$message.warning(this.$t('Message.PleaseSelect') + this.$t('CargoMsg.Cargo_ContractAgreement'))
        this.saveBtnEnabled = false
        return false
      }
      return true
    },
    initCurrencySet() {
      if (this.creditUseMultipleCurrency) {
        const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
        const priorityCurrencies = results.filter(currency =>
          currency.code === 'RMB' || currency.code === 'USD' || currency.code === 'EUR')
        const otherCurrencies = results.filter(currency =>
          currency.code !== 'RMB' && currency.code !== 'USD' && currency.code !== 'EUR')
        this.currencySet = new Set([...priorityCurrencies, ...otherCurrencies])
      } else {
        this.currencySet = new Set([{ code: 'RMB' }, { code: 'USD' }])
      }
    },
    contactMultipleChange() {
      // 取消勾选 同时取消勾选其他选项
      if (!this.cm.contactMultiple) {
        this.cm.clientContract = false
        this.cm.supplierContract = false
        this.cm.overseasAgencyContract = false
        this.cm.otherContact = false
      }
    },
    async currencyChanged() {
      if (!this.creditUseMultipleCurrency) {
        return
      }
      this.contract.currency
      const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      let invalid = false
      let localCurrency = ''
      const invalidCurrencyList = []
      const currencyList = await getSpecificBasicData(basicCacheKeys.basic_data_Currency)
      const useLocalCurrency = RateUtil.useLocalCurrency()
      if (useLocalCurrency) {
        for (const office of officeList) {
          localCurrency = office.currency
          if (localCurrency) {
            const needCheck = office.currency !== this.contract.currency
            const rate = await RateUtil.getForeignExchangeRateSafely(localCurrency, this.contract.currency, new Date(), 0, 0, false, true)
            if (needCheck && (isNaN(rate) || rate === 0)) {
              let hasRate = false
              for (const currency of currencyList) {
                const code = currency.code
                const localRate = await RateUtil.getForeignExchangeRateSafely(localCurrency, code, new Date(), 0, 0, false, true)
                const toLocalRate = await RateUtil.getForeignExchangeRateSafely(code, this.contract.currency, new Date(), 0, 0, false, true)
                if (!isNaN(localRate) && localRate !== 0 && !isNaN(toLocalRate) && toLocalRate !== 0) {
                  hasRate = true
                  break
                }
              }
              if (!hasRate) {
                invalid = true
                if (!invalidCurrencyList.includes(localCurrency)) {
                  invalidCurrencyList.push(localCurrency)
                }
              }
            }
          }
        }
      } else {
        const rate = await RateUtil.getForeignExchangeRateSafely('RMB', this.contract.currency, new Date(), 0, 0, false, true)
        invalid = (isNaN(rate) || rate === 0)
        if (invalid) {
          invalidCurrencyList.push('RMB')
        }
      }
      if (invalid) {
        this.$message.warning(this.$t('Information.unSupportContractCurrency', [this.contract.currency, invalidCurrencyList.join(',')]))
        this.contract.currency = this.lastCurrency
      } else {
        this.lastCurrency = this.contract.currency
      }
    },
    // 顺延周期时间追加到失效日期
    postponeTypeChangeHandler() {
      return // 20190827，review备注: 系统不自动计算失效日期
      // 上一行cargo这边就是return，所以下面的代码屏蔽了
      // if (!chkPostpone.selected || dfEndDate.selectedDate == null) return;
      // // 失效日期
      // var endDate:Date = contract.endDate == null ? dfEndDate.selectedDate : contract.endDate;
      // switch (postponeTypeGroup.selectedValue.toString()) {
      //   case "1": // 1 年
      //     dfEndDate.selectedDate = new Date(endDate.fullYear + 1, endDate.month, endDate.date);
      //     break;
      //   case "2": // 2 年
      //     dfEndDate.selectedDate = new Date(endDate.fullYear + 2, endDate.month, endDate.date);
      //     break;
      //   case "3": // 3 年
      //     dfEndDate.selectedDate = new Date(endDate.fullYear + 3, endDate.month, endDate.date);
      //     break;
      //   case "9": // 其他
      //     var postponeLimited:int = int(tiPostponeLimited.text);
      //     if (postponeLimited > 0) {
      //       var postponeUnit:int = int(cbPostponeUnit.selectedItem.value);
      //       switch (postponeUnit.toString())
      //       {
      //         case "0": // 天
      //           dfEndDate.selectedDate = new Date(endDate.fullYear, endDate.month, endDate.date + postponeLimited);
      //           break;
      //         case "1": // 周
      //           dfEndDate.selectedDate = new Date(endDate.fullYear, endDate.month, endDate.date + postponeLimited * 7);
      //           break;
      //         case "2": // 月
      //           dfEndDate.selectedDate = new Date(endDate.fullYear, endDate.month + postponeLimited, endDate.date);
      //           break;
      //         default:
      //           break;
      //       }
      //     }
      //     break;
      //   default:
      //     break;
      // }
    },
    changePaymentTerm(paymentTerm) {
      // 单位为日时累加
      this.contract.snapCreditDateLimited = paymentTerm
      if (paymentTerm !== 0 && this.contract.paymentTermUnit === UNIT_DAY.code) {
        this.contract.snapCreditDateLimited = this.actualCreditGracePeriodDays + paymentTerm
      }
    },
    changePaymentTermUnit(paymentTermUnit) {
      // 单位为日时累加
      this.contract.paymentTermUnit = paymentTermUnit
      this.contract.termUnit = paymentTermUnit
      this.contract.snapCreditDateLimited = this.contract.paymentTerm
      if (this.contract.snapCreditDateLimited !== 0 && paymentTermUnit === UNIT_DAY.code) {
        this.contract.snapCreditDateLimited = this.actualCreditGracePeriodDays + this.contract.paymentTerm
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-tip{
  vertical-align: middle;
  margin-bottom: 4px;
  margin-left: 2px;
  color: orange;
  font-size: 18px;
  cursor: pointer;
}
</style>
